// src/components/InfoTooltip.js
import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const InfoTooltip = ({ title }) => (
  <Tooltip title={title} arrow>
    <IconButton size="small" sx={{ ml: 1 }}>
      <InfoIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);

export default InfoTooltip;
